const defaults = {
  encoding: 'utf-8',
  binaryPropertyName: 'data',
  trimOutput: true,
  removeBom: true,
};

export default defaults;
